import { render, staticRenderFns } from "./TheNotes.vue?vue&type=template&id=2e2027f6&scoped=true&"
import script from "./TheNotes.vue?vue&type=script&lang=js&"
export * from "./TheNotes.vue?vue&type=script&lang=js&"
import style0 from "./TheNotes.vue?vue&type=style&index=0&id=2e2027f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2027f6",
  null
  
)

export default component.exports